export default __webpack_public_path__ + "static/media/forms-select-arrow.fb5de707.svg";